module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAL1JREFUOE+V0z8KwjAYBfD3QEHIAfQIDgp6Ax0EL+CgPV9x8BC6Oyjo0CPoAbIo+ElaqS1p/mV+v5C85CMSF01eduoMoocP1tzrp2+PCmTqBnACQQGRhQ9VYKNG6PMIYhxCJUhBNYhFLRCDLBBCncCHnMBCkDtzPfWDrRqCPJV1Q67M9dx9pGbYPOhbljzoR/elHWFzTLtWT9gCEgi3QEy4BrHhP8jUBeCs/Km/Nlwz0RygAV5YmeqCA5QypV+2PZYVGsgw8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/img22.png
// module id = HWGa
// module chunks = 1